/* Import Local Modules */
import ReconcileLost from './ReconcileLost';
export default {
  install(molten) {
    molten.addPlugin('Action', ReconcileLost);
  }
};